import { render, staticRenderFns } from "./RevenuePerVehicle.vue?vue&type=template&id=61003de0&scoped=true&"
import script from "./RevenuePerVehicle.vue?vue&type=script&lang=js&"
export * from "./RevenuePerVehicle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61003de0",
  null
  
)

export default component.exports